import { Component, OnInit } from '@angular/core';
import {HomemadeOrganic} from '../../shared/models/homemade_organic';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {HomemadeOrganicService} from '../../shared/services/homemade-organic.service';
import {Gap} from '../../shared/models/gap';
import {GapService} from '../../shared/services/gap.service';
import {AppSettings} from '../../app.settings';
import {MessageService} from '../../shared/messages/message.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-gap-details',
  templateUrl: './gap-details.component.html',
  styleUrls: ['./gap-details.component.css']
})
export class GapDetailsComponent implements OnInit {

  baseUrl = environment.baseUrl;
  defaultImage = environment.defaultImage;
  errorImage = environment.errorImage;
  id: any;
  loading = true;
  loaded = false;
  gap: Gap;

  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private gapService: GapService,
    public messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.params.id;
    this.getItem();
  }

  private getItem() {
    // Get GAP item based on id
    this.gapService.findById(this.id).subscribe(response => {
        this.gap = response.data;
        this.loading = false;
        this.loaded = true;
        this.titleService.setTitle(this.gap.name);
      },
      error => {
        // Error handling
        this.messageService.showMessage('info', 'Not found', 'Good application practice not found');
        this.loading = false;
      });
  }
}
